import { render, staticRenderFns } from "./OrbitLeaderboardContent.vue?vue&type=template&id=8df6ef54&scoped=true"
import script from "./OrbitLeaderboardContent.vue?vue&type=script&lang=ts"
export * from "./OrbitLeaderboardContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df6ef54",
  null
  
)

export default component.exports